// extracted by mini-css-extract-plugin
module.exports = {"loading_background":"loading_loading_background__1R3Rz","svg":"loading_svg__3QT6E"};